module.exports = __webpack_public_path__ + "static/media/25.883a8480.jpg";